import React from "react";
import { Text, TouchableOpacity } from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { openMenu } from "../redux/actions/menu";
import { RepositColours } from "../utils/styles";

const MenuIcon = <Icon name="navicon" size={26} color={RepositColours.blue} />;

const mapStateToProps = (state) => ({
  menu: state.menu,
});

const mapDispatchToProps = (dispatch) => {
  return {
    menuActions: bindActionCreators({ openMenu }, dispatch),
  };
};

class MenuButton extends React.Component {
  render() {
    return (
      <TouchableOpacity
        style={{ width: 80 }}
        onPress={() => this.props.menuActions.openMenu()}
      >
        <Text style={{ marginRight: 20, textAlign: "right" }}>{MenuIcon}</Text>
      </TouchableOpacity>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuButton);



// WEBPACK FOOTER //
// ./src/components/MenuButton.js